import { useEffect, useRef } from 'react';

/**
 * Fire a submit callback exactly once on mount.
 * Used by auto-advancing steps (ConsumingInvite, AutoStartIdp).
 */
export function useSubmitOnceOnMount(submit: (payload?: unknown) => void): void {
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) return;
    hasStartedRef.current = true;
    submit();
  }, [submit]);
}
